import styled from 'styled-components';

export const StyledTabListWrapper = styled('div')`
  border-bottom: 1px solid ${({ theme }) => theme.color.spaceGray};
`;
